import request from '../helpers/request';

const tickets = {};

tickets.index = (filters = {}) => request.get('/tickets', filters, true);
tickets.get = (id) => request.get('/tickets/get', { id }, true);
tickets.add = (data) => request.post('/tickets/add', { subject: data.subject, message: data.message }, true);
tickets.edit = (data) => request.put('/tickets/edit', data, true);

export default tickets;
